import { roleAtLeast } from "@/lib/roles";

/** The Businesses panel + tenant switcher are the first owner-only surfaces (#232). Admins
 *  and operators must see neither — the API enforces this independently (403). */
export function canAccessBusinesses(role: string): boolean {
  return roleAtLeast(role, "owner");
}
